import DisplayObject = createjs.DisplayObject;
import Container = createjs.Container;
import Sprite = createjs.Sprite;
import ColorTransform = createjs.ColorTransform;
import ColorFilter = createjs.ColorFilter;
import MovieClip = createjs.MovieClip;

export class ClipColor {
    private _colors: number[];

    public get colors(): number[] {
        return this._colors;
    }

    private _colorID: string;

    public get colorID(): string {
        return this._colorID;
    }

    private _colorChangeLayerName: string;

    private _singleColorPrefix: string;

    private static ct: ColorTransform = new ColorTransform();

    constructor(colorChangeLayerName: string, colors: number[], singleColorPrefix: string = "c") {
        this._colorChangeLayerName = colorChangeLayerName;
        this._colors = colors;
        this._singleColorPrefix = singleColorPrefix;
        this.initColorID();
    }

    private initColorID(): void {
        this._colorID = null;

        if (this._colors && this._colors.length > 0) {
            this._colorID = "";

            for (let i: number = 0; i < this._colors.length; i++) {
                this._colorID += String(this._colors[i]);
            }
        }
    }

    public colorClip(source: DisplayObject): void {
        this.colorLayer(source as Container);
        let ccLayer: Container;
        let colorLayerID: number = 0;

        do {
            ccLayer = source[this._colorChangeLayerName + colorLayerID];
            colorLayerID++;
            this.colorLayer(ccLayer);
        }
        while (ccLayer);
    }

    private colorLayer(ccLayer: Container): void {
        if (!ccLayer) {
            return;
        }

        for (let i: number = 0; i < this.colors.length; i++) {
            let singleColorLayer: Container = ccLayer[this._singleColorPrefix + String(i + 1)];
            ClipColor.ct.color = this.colors[i];

            if (singleColorLayer) {
                //singleColorLayer.transform.colorTransform = ClipColor.ct;
                let ct = ClipColor.ct;
                if (singleColorLayer instanceof MovieClip && singleColorLayer.children.length === 0) {
                    // c1 c2 ... can also be moveclip
                    singleColorLayer.gotoAndStop(1);
                }
                singleColorLayer.useFilters([new ColorFilter(ct.redMultiplier, ct.greenMultiplier, ct.blueMultiplier, ct.alphaMultiplier, ct.redOffset, ct.greenOffset, ct.blueOffset, ct.alphaOffset)]);
            } else {
                break;
            }
        }
    }
}
